// ========================================
// Category Dashboards — Core Registry & Setup
// ========================================

window.CategoryDashboards = window.CategoryDashboards || {
    _editMode: {},

    _widgetDescriptions: {
        // Panel Académico (diseño C2 del 2026-10-25)
        'aca-semana': 'Las clases de cada día de la semana, con su lista pasada o no; cada una lleva a su programación.',
        'aca-cifras': 'Formaciones, clases del mes, lista pasada, memorias, calificaciones y tareas en una franja.',
        'aca-mes': 'El mes con los días que tienen clase y los festivos; al pulsar un día salen sus clases.',
        'aca-lista-meses': 'Clases con la lista pasada en cada uno de los tres últimos meses.',
        'aca-tipos': 'Cuántas formaciones hay de cada tipo.',
        'aca-imparticion': 'Asignaturas que se imparten este mes, con sus horas.',
        'aca-aulas': 'Cada aula de hoy con su día en una barra: en uso, libre y la siguiente clase.',
        'aca-herramientas': 'Accesos a las páginas académicas.',

        // Inicio (diseño A2 del 2026-10-25)
        'inicio-pendiente': 'Lo que espera hoy: solicitudes, contactos, nóminas, justificantes, material y compras. Cada cifra lleva a donde se resuelve.',
        'inicio-dinero': 'Previsión de matrículas, cobrado, pendiente de cobro, gastos de personal y margen del curso.',
        'inicio-hoy': 'Clases y entrevistas de hoy, por hora.',
        'inicio-admisiones': 'Solicitudes de admisión por paso, con la lista de pendientes, aprobadas y rechazadas.',
        'inicio-academico': 'Formaciones, asistencia de los últimos 3 meses, memorias entregadas y aulas en uso hoy.',
        'inicio-contactos': 'Contactos sin contestar, contactados y con visita, y los últimos que han llegado.',
        'inicio-docencia': 'Nóminas que faltan de los meses que ya tocan (desde el día 28) y docentes con clase hoy.',
        'inicio-logistica': 'Solicitudes de material, stock crítico y compras por firmar.',
        'inicio-alumnado': 'Una muestra de alumnos activos con su usuario, formación y matrícula.',
        'inicio-semana': 'Las clases de cada día de esta semana; cada una lleva a su programación.',
        'inicio-mensajes': 'Mensajes sin leer de tu buzón.',
        'inicio-festivos': 'Próximos días no lectivos del calendario escolar.',
        'inicio-accesos': 'Accesos directos a las páginas más usadas.',

        // Panel Alumnado y CRM (diseño A del 2026-10-25)
        'crm-embudo': 'Los seis pasos de un contacto hasta la matrícula, con cuántos hay en cada uno.',
        'crm-por-contactar': 'Los últimos contactos sin contestar, con su interés, origen y lo que llevan esperando.',
        'crm-entrevistas': 'Entrevistas de admisión pedidas: las próximas con fecha y las que faltan por fijar.',
        'crm-cifras': 'Alumnos activos, pre-matriculados, bajas, solicitudes por revisar y conversión.',
        'crm-meses': 'Contactos que han llegado en cada uno de los últimos cuatro meses.',
        'crm-interes': 'Formaciones que más piden los contactos.',
        'crm-tutorias': 'Tutorías de esta semana, las próximas y las que faltan por confirmar.',
        'crm-herramientas': 'Accesos a las páginas de alumnado y admisiones.',

        // Personal y RRHH
        'rrhh-pendientes': 'Lo que espera a RRHH hoy: vacaciones y permisos por aprobar, nóminas del mes anterior que faltan, avisos a la asesoría y justificantes sin revisar.',
        'kpi-coste-mes': 'Coste empresa real del último mes con nóminas subidas.',
        'permisos-aprobar': 'Solicitudes de vacaciones y permisos sin sueldo pendientes, para aprobarlas o rechazarlas aquí mismo.',
        'fuera-semana': 'Quién tiene vacaciones o permiso esta semana, día a día.',
        'coste-curso': 'Coste empresa real de cada mes del curso, separado en sueldos fijos y por horas.',
        'altas-bajas': 'Altas y bajas de los próximos meses, con las altas sin notificar a la asesoría.',
        'justificantes-recientes': 'Los últimos justificantes recibidos; los no revisados se marcan.',
        'plantilla-tipos': 'Personal en activo por tipo de pago (fijo, por horas, autónomo) y quién no tiene tarifa.',
        'contratacion-donut': 'Antigüedad de la plantilla activa: docentes consolidados frente a nuevas incorporaciones.',
        'kpi-plantilla': 'Personal de alta hoy (con fecha de alta y sin baja).',
        'kpi-nominas': 'Porcentaje de nóminas subidas del último mes que ya toca (desde el día 28, el mes en curso) sobre quienes tuvieron clases o contrato ese mes.',

        // Logística
        // Panel Logística (diseño A del 2026-10-26)
        'lo-pendiente': 'Reservas por aprobar, material por entregar, devoluciones atrasadas, compras por firmar y stock crítico.',
        'lo-cifras': 'Referencias y unidades, material en estantería y en préstamo, y reservas de la semana.',
        'lo-prestamos': 'Préstamos de rodaje en curso y aprobados, con cuándo vuelven o se recogen.',
        'lo-disponibilidad': 'Material en estantería y en préstamo, y el que se está acabando.',
        'lo-mapa': 'El plano del Mapa interactivo con las aulas en uso ahora, libres o con clase más tarde.',
        'lo-categorias': 'Unidades de material de cada categoría.',
        'lo-meses': 'Reservas de material pedidas en cada uno de los últimos seis meses.',
        'lo-herramientas': 'Accesos al inventario, reservas, compras, mapa de aulas y distribución.',
        'quick-nav': 'Accesos rápidos a los módulos y herramientas de esta sección.'
    },

    // Qué sección de la matriz de Permisos por Rol (#permisos-roles) gobierna
    // cada widget de estos dashboards de departamento. Los widgets de
    // navegación pura ('quick-nav', 'modulos') no representan ninguna sección
    // y no se filtran — son accesos directos, no contenido sensible.
    WIDGET_SECTION_MAP: {
        // Panel Académico: 'aca-cifras' y 'aca-herramientas' filtran cada cifra o botón por su cuenta.
        'aca-semana': 'calendario-formacion',
        'aca-mes': 'calendario',
        'aca-lista-meses': 'asistencia',
        'aca-tipos': 'formaciones',
        'aca-imparticion': 'plan-estudios',
        'aca-aulas': 'calendario-formacion',

        // Panel Alumnado y CRM: 'crm-cifras' y 'crm-herramientas' filtran cada cifra o botón por su cuenta.
        'crm-embudo': 'leads',
        'crm-por-contactar': 'leads',
        'crm-entrevistas': 'entrevistas',
        'crm-meses': 'leads',
        'crm-interes': 'leads',
        'crm-tutorias': 'tutorias-admin',

        'kpi-plantilla': 'profesores',
        'rrhh-pendientes': 'profesores',
        'kpi-coste-mes': 'nominas',
        'permisos-aprobar': 'profesores',
        'fuera-semana': 'profesores',
        'coste-curso': 'nominas',
        'altas-bajas': 'profesores',
        'justificantes-recientes': 'justificantes',
        'plantilla-tipos': 'profesores',
        'kpi-nominas': 'nominas',
        'contratacion-donut': 'profesores',

        // Panel Logística: 'lo-herramientas' filtra cada botón por su cuenta.
        'lo-pendiente': 'almacen',
        'lo-cifras': 'almacen',
        'lo-prestamos': 'almacen',
        'lo-disponibilidad': 'almacen',
        'lo-mapa': 'mapa-interactivo',
        'lo-categorias': 'almacen',
        'lo-meses': 'almacen',

        // Inicio ('dashboard') — 'inicio-pendiente' filtra cada cifra por su cuenta y
        // 'inicio-accesos' es solo navegación, igual que 'quick-nav'/'modulos'.
        'inicio-dinero': 'pre-matricula',
        'inicio-hoy': 'calendario',
        'inicio-admisiones': 'pre-matricula',
        'inicio-academico': 'panel-academico',
        'inicio-contactos': 'leads',
        'inicio-docencia': 'nominas',
        'inicio-logistica': 'almacen',
        'inicio-semana': 'calendario',
        'inicio-mensajes': 'mensajes',
        'inicio-festivos': 'calendario'
    },

    filterWidgetsByRolePermission(widgets) {
        if (typeof RolePermissions === 'undefined') return widgets;
        return widgets.filter(w => {
            const sectionKey = this.WIDGET_SECTION_MAP[w.id];
            if (!sectionKey) return true;
            return RolePermissions.canViewSection(sectionKey);
        });
    },

    getDefaultWidgets(dashboardId) {
        if (dashboardId === 'academico') {
            // Diseño C2 del 2026-10-25; ids nuevos para que las distribuciones guardadas empiecen de cero.
            return [
                { id: 'aca-semana', name: 'La semana', visible: true, span: 3 },
                { id: 'aca-cifras', name: 'Cifras', visible: true, span: 3 },
                { id: 'aca-mes', name: 'Calendario del mes', visible: true, span: 1 },
                { id: 'aca-lista-meses', name: 'Lista pasada por mes', visible: true, span: 1 },
                { id: 'aca-tipos', name: 'Formaciones por tipo', visible: true, span: 1 },
                { id: 'aca-imparticion', name: 'En impartición este mes', visible: true, span: 1 },
                { id: 'aca-aulas', name: 'Aulas hoy', visible: true, span: 2 },
                { id: 'aca-herramientas', name: 'Herramientas', visible: true, span: 3 }
            ];
        }
        if (dashboardId === 'alumnocrm') {
            // Diseño A del 2026-10-25; ids nuevos para que las distribuciones guardadas empiecen de cero.
            return [
                { id: 'crm-embudo', name: 'Del primer contacto a la matrícula', visible: true, span: 3 },
                { id: 'crm-por-contactar', name: 'Por contactar', visible: true, span: 2 },
                { id: 'crm-entrevistas', name: 'Próximas entrevistas', visible: true, span: 1 },
                { id: 'crm-cifras', name: 'Cifras de alumnado', visible: true, span: 3 },
                { id: 'crm-meses', name: 'Contactos por mes', visible: true, span: 1 },
                { id: 'crm-interes', name: 'Interés por formación', visible: true, span: 1 },
                { id: 'crm-tutorias', name: 'Tutorías', visible: true, span: 1 },
                { id: 'crm-herramientas', name: 'Herramientas', visible: true, span: 3 }
            ];
        }
        if (dashboardId === 'rrhh') {
            // Diseño del 2026-10-20: primero lo pendiente. De los widgets anteriores solo
            // queda «Antigüedad», oculto; el resto repetía lo que ya muestran los nuevos.
            return [
                { id: 'rrhh-pendientes', name: 'Pendientes de hoy', visible: true, span: 3 },
                { id: 'kpi-plantilla', name: 'KPI: Plantilla Activa', visible: true, span: 1 },
                { id: 'kpi-coste-mes', name: 'KPI: Coste del Último Mes', visible: true, span: 1 },
                { id: 'kpi-nominas', name: 'KPI: Nóminas Subidas', visible: true, span: 1 },
                { id: 'permisos-aprobar', name: 'Vacaciones y Permisos por Aprobar', visible: true, span: 2 },
                { id: 'fuera-semana', name: 'Fuera Esta Semana', visible: true, span: 1 },
                { id: 'coste-curso', name: 'Coste Empresa del Curso', visible: true, span: 2 },
                { id: 'altas-bajas', name: 'Altas y Bajas Próximas', visible: true, span: 1 },
                { id: 'justificantes-recientes', name: 'Justificantes Recientes', visible: true, span: 2 },
                { id: 'plantilla-tipos', name: 'Plantilla por Tipo de Pago', visible: true, span: 1 },
                { id: 'contratacion-donut', name: 'Antigüedad de la Plantilla', visible: false, span: 1 }
            ];
        }
        if (dashboardId === 'logistica') {
            // Diseño A del 2026-10-26; ids nuevos para que las distribuciones guardadas empiecen de cero.
            return [
                { id: 'lo-pendiente', name: 'Pendiente', visible: true, span: 3 },
                { id: 'lo-cifras', name: 'Cifras del material', visible: true, span: 3 },
                { id: 'lo-prestamos', name: 'Préstamos de rodaje', visible: true, span: 2 },
                { id: 'lo-disponibilidad', name: 'Disponibilidad', visible: true, span: 1 },
                { id: 'lo-mapa', name: 'Mapa de aulas', visible: true, span: 2 },
                { id: 'lo-categorias', name: 'Material por categoría', visible: true, span: 1 },
                { id: 'lo-meses', name: 'Reservas por mes', visible: true, span: 3 },
                { id: 'lo-herramientas', name: 'Herramientas', visible: true, span: 3 }
            ];
        }
        if (dashboardId === 'dashboard') {
            // Diseño A2 del 2026-10-25. Ids nuevos a propósito: las distribuciones guardadas
            // con los widgets anteriores no casan y cada cuenta empieza con este orden.
            return [
                { id: 'inicio-pendiente', name: 'Pendiente hoy', visible: true, span: 3 },
                { id: 'inicio-dinero', name: 'Resumen financiero', visible: true, span: 3 },
                { id: 'inicio-hoy', name: 'Hoy en el centro', visible: true, span: 2 },
                { id: 'inicio-admisiones', name: 'Solicitudes de admisión', visible: true, span: 1 },
                { id: 'inicio-academico', name: 'Académico', visible: true, span: 3 },
                { id: 'inicio-contactos', name: 'Contactos', visible: true, span: 1 },
                { id: 'inicio-docencia', name: 'Docencia y nóminas', visible: true, span: 1 },
                { id: 'inicio-logistica', name: 'Logística y almacén', visible: true, span: 1 },
                { id: 'inicio-alumnado', name: 'Alumnado registrado', visible: true, span: 3 },
                { id: 'inicio-semana', name: 'Calendario · esta semana', visible: true, span: 3 },
                { id: 'inicio-mensajes', name: 'Mensajes recientes', visible: true, span: 1 },
                { id: 'inicio-festivos', name: 'Próximos festivos', visible: true, span: 1 },
                { id: 'inicio-accesos', name: 'Accesos rápidos', visible: true, span: 1 }
            ];
        }
        return [];
    },

    getWidgetsConfig(dashboardId) {
        const currentUser = typeof AuthManager !== 'undefined' ? AuthManager.getCurrentUser() : null;
        const userId = currentUser ? (currentUser.id || currentUser.username || 'user') : 'default';
        const key = `ecpv_dashboard_config_${dashboardId}_${userId}`;
        const saved = BrowserState.getItem(key);
        const defaultWidgets = this.filterWidgetsByRolePermission(this.getDefaultWidgets(dashboardId));

        if (!saved) return defaultWidgets;

        try {
            const parsed = JSON.parse(saved);
            const merged = [];
            parsed.forEach(savedW => {
                const def = defaultWidgets.find(d => d.id === savedW.id);
                if (def) {
                    merged.push({
                        ...def,
                        visible: savedW.visible !== undefined ? savedW.visible : def.visible,
                        span: savedW.span || def.span
                    });
                }
            });
            // Un widget nuevo (que no estaba en la config ya guardada del usuario) se
            // insertaba siempre al final absoluto de la rejilla, aunque en
            // getDefaultWidgets() estuviera pensado para ir arriba — con un widget de
            // ancho completo al final (p.ej. "Módulos y Herramientas") quedaba oculto
            // tras él, dando la sensación de que había desaparecido. Se inserta ahora
            // justo después de su vecino anterior "conocido" para respetar el orden por
            // defecto sin descartar el reordenado manual que el usuario ya guardó.
            defaultWidgets.forEach((def, idx) => {
                if (merged.find(m => m.id === def.id)) return;
                let insertAt = merged.length;
                for (let j = idx - 1; j >= 0; j--) {
                    const prevPos = merged.findIndex(m => m.id === defaultWidgets[j].id);
                    if (prevPos !== -1) {
                        insertAt = prevPos + 1;
                        break;
                    }
                }
                merged.splice(insertAt, 0, def);
            });
            return merged;
        } catch (e) {
            console.error('Error parsing dashboard widget config:', e);
            return defaultWidgets;
        }
    },

    saveWidgetsConfig(dashboardId, widgets) {
        const currentUser = typeof AuthManager !== 'undefined' ? AuthManager.getCurrentUser() : null;
        const userId = currentUser ? (currentUser.id || currentUser.username || 'user') : 'default';
        const key = `ecpv_dashboard_config_${dashboardId}_${userId}`;
        const clean = widgets.map(w => ({
            id: w.id,
            visible: w.visible,
            span: w.span
        }));
        // In-memory draft for immediate feedback; not a confirmed server save.
        BrowserState.setItem(key, JSON.stringify(clean));
        this._configRevision = (this._configRevision || 0) + 1;
        const epoch = AuthManager._epoch;
        // Rapid drags/size changes must reach the server in the same order.
        const pending = (this._widgetSaveQueue || Promise.resolve()).then(async () => {
            if (epoch !== AuthManager._epoch) return false;
            try {
                await this._persistWidgetsConfigRemote(dashboardId, clean);
                return epoch === AuthManager._epoch;
            } catch (error) {
                if (epoch === AuthManager._epoch) Utils.showToast('No se pudo guardar la distribución. Conserva esta página y vuelve a pulsar Guardar y Listo.', 'error');
                return false;
            }
        });
        this._widgetSaveQueue = pending;
        return pending;
    },

    async _persistWidgetsConfigRemote(dashboardId, widgets) {
        const token = AuthManager.getCsrfToken();
        if (!token) throw new Error('Inicia sesión antes de guardar.');
        const response = await fetch(`/api/widget-config/${encodeURIComponent(dashboardId)}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'X-SICAF-CSRF': token },
            body: JSON.stringify({ widgets })
        });
        const result = await response.json().catch(() => null);
        if (!response.ok || !result?.success) throw new Error('No se pudo guardar la distribución.');
    },

    // Trae la configuración de widgets guardada en la base de datos y la vuelca
    // en BrowserState (misma clave que usa getWidgetsConfig) para que las vistas
    // ya renderizadas se actualicen inmediatamente si hacía falta.
    async syncWidgetConfigFromServer() {
        const epoch = AuthManager._epoch;
        const revision = this._configRevision || 0;
        try {
            const token = typeof AuthManager !== 'undefined' ? AuthManager.getCsrfToken() : AuthManager.getCsrfToken();
            if (!token) return;
            const res = await fetch('/api/widget-config', { headers: { 'X-SICAF-CSRF': token } });
            const data = await res.json();
            if (epoch !== AuthManager._epoch || revision !== (this._configRevision || 0)) return;
            if (!res.ok || !data.success || !data.config || typeof data.config !== 'object' || Array.isArray(data.config)) return;

            const currentUser = typeof AuthManager !== 'undefined' ? AuthManager.getCurrentUser() : null;
            const userId = currentUser ? (currentUser.id || currentUser.username || 'user') : 'default';

            Object.keys(data.config).forEach(dashboardId => {
                if (this.isEditMode(dashboardId) || !this.getDefaultWidgets(dashboardId).length || !Array.isArray(data.config[dashboardId])) return;
                const key = `ecpv_dashboard_config_${dashboardId}_${userId}`;
                BrowserState.setItem(key, JSON.stringify(data.config[dashboardId]));
            });

            // Si ya se había pintado un dashboard personalizable con la config por
            // defecto (antes de que llegara la respuesta del servidor), refréscalo.
            if (typeof App !== 'undefined' && this.getDefaultWidgets(App.currentView).length && !this.isEditMode(App.currentView)) {
                this.reRenderDashboard(App.currentView);
            }
        } catch (e) {
            console.error('Error al sincronizar la configuración de widgets desde el servidor:', e);
        }
    },

    isEditMode(dashboardId) {
        if (!this._editMode) this._editMode = {};
        return !!this._editMode[dashboardId];
    },

    // Cuenta hacia arriba los elementos [data-count-to] desde 0 hasta su valor final.
    // Compartido por todos los paneles (dashboard, académico, CRM, RRHH, logística).
    animateCounters(root) {
        const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        (root || document).querySelectorAll('[data-count-to]').forEach(el => {
            const target = parseFloat(el.dataset.countTo);
            if (Number.isNaN(target)) return;
            const suffix = el.dataset.countSuffix || '';
            if (reduced) { el.textContent = `${target.toLocaleString('es-ES')}${suffix}`; return; }
            const duration = 700;
            const start = performance.now();
            const easeOutCubic = t => 1 - Math.pow(1 - t, 3);
            const frame = (now) => {
                const t = Math.min(1, (now - start) / duration);
                el.textContent = `${Math.round(target * easeOutCubic(t)).toLocaleString('es-ES')}${suffix}`;
                if (t < 1) requestAnimationFrame(frame);
            };
            requestAnimationFrame(frame);
        });
    },

    toggleToolsDropdown(dashboardId) {
        const dropdown = document.getElementById(`tools-dropdown-${dashboardId}`);
        if (dropdown) {
            dropdown.style.display = dropdown.style.display === 'none' ? 'block' : 'none';
        }
    },

    toggleWidgetDrawer(dashboardId) {
        if (this._editMode && this._editMode[dashboardId]) return;

        const drawer = document.getElementById(`widget-drawer-${dashboardId}`);
        const overlay = document.getElementById(`widget-drawer-overlay-${dashboardId}`);
        if (!drawer) return;
        const isOpen = drawer.style.transform === 'translateX(0px)' || drawer.style.transform === 'translateX(0)';
        if (isOpen) {
            drawer.style.transform = 'translateX(100%)';
            if (overlay) overlay.style.opacity = '0';
            setTimeout(() => { 
                if (overlay) overlay.style.display = 'none'; 
                drawer.style.visibility = 'hidden';
            }, 250);
        } else {
            drawer.style.visibility = 'visible';
            if (overlay) { overlay.style.display = 'block'; requestAnimationFrame(() => { overlay.style.opacity = '1'; }); }
            requestAnimationFrame(() => { drawer.style.transform = 'translateX(0)'; });
        }
    },

    async toggleEditMode(dashboardId) {
        if (!this._editMode) this._editMode = {};
        if (this._finishingWidgets) return;
        if (this._editMode[dashboardId]) {
            this._finishingWidgets = dashboardId;
            const epoch = AuthManager._epoch;
            const buttons = document.querySelectorAll(`#edit-banner-${dashboardId} button, #btn-edit-toggle-${dashboardId}`);
            buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
            let saved;
            try { saved = await this.saveWidgetsConfig(dashboardId, this.readWidgetOrder(dashboardId)); }
            finally {
                this._finishingWidgets = null;
                buttons.forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); });
            }
            if (!saved || epoch !== AuthManager._epoch) return;
            Utils.showToast('Distribución guardada', 'success');
        }
        this._editMode[dashboardId] = !this._editMode[dashboardId];
        const isEdit = this._editMode[dashboardId];

        const drawer = document.getElementById(`widget-drawer-${dashboardId}`);
        const overlay = document.getElementById(`widget-drawer-overlay-${dashboardId}`);
        if (isEdit) {
            if (drawer) { drawer.style.display = 'none'; }
            if (overlay) { overlay.style.opacity = '0'; overlay.style.display = 'none'; }
        } else {
            if (drawer) {
                drawer.style.display = 'flex';
                drawer.style.transform = 'translateX(100%)';
                drawer.style.visibility = 'hidden';
            }
        }

        const banner = document.getElementById(`edit-banner-${dashboardId}`);
        if (banner) banner.style.display = isEdit ? 'flex' : 'none';

        const btnEditToggle = document.getElementById(`btn-edit-toggle-${dashboardId}`);
        if (btnEditToggle) {
            btnEditToggle.style.background = isEdit ? '#ef4444' : '#0d9488';
            SafeHTML.set(btnEditToggle, `<i class="fas ${isEdit ? 'fa-check-circle' : 'fa-edit'}"></i> ${isEdit ? 'Finalizar Edición' : 'Editar Posición y Tamaño'}`);
        }

        const grid = document.getElementById(`widgets-grid-${dashboardId}`);
        if (grid) {
            grid.querySelectorAll('.dashboard-widget-card').forEach(card => {
                const controls = card.querySelector('.widget-edit-controls-bar');
                if (controls) controls.style.display = isEdit ? 'flex' : 'none';
                card.draggable = isEdit;
                card.style.cursor = isEdit ? 'grab' : 'pointer';
                card.style.border = isEdit ? '2px dashed #0d9488' : '1px solid rgba(0,0,0,0.06)';
            });
        }

        if (isEdit) {
            this.attachDragAndDrop(dashboardId);
        }

        const cogBtn = document.getElementById(`btn-cog-${dashboardId}`);
        if (cogBtn) cogBtn.style.display = isEdit ? 'none' : 'flex';
    },

    toggleWidgetVisibility(dashboardId, widgetId) {
        if (this._finishingWidgets) return;
        const config = this.getWidgetsConfig(dashboardId);
        const widget = config.find(w => w.id === widgetId);
        if (widget) {
            widget.visible = !widget.visible;
            this.saveWidgetsConfig(dashboardId, config);

            const card = document.getElementById(`widget-${widgetId}`);
            if (card) card.style.display = widget.visible ? 'flex' : 'none';

            const track = document.getElementById(`toggle-track-${widgetId}`);
            const thumb = document.getElementById(`toggle-thumb-${widgetId}`);
            if (track) track.style.background = widget.visible ? '#0d9488' : '#cbd5e1';
            if (thumb) thumb.style.left = widget.visible ? '19px' : '3px';

            const spanSel = document.getElementById(`span-selector-${widgetId}`);
            if (spanSel) spanSel.style.display = widget.visible ? 'flex' : 'none';

            const drawerRow = track ? track.closest('div[style*="padding:0.85rem"]') : null;
            if (drawerRow) {
                const nameEl = drawerRow.querySelector('div[style*="font-weight:700"]');
                if (nameEl) nameEl.style.color = widget.visible ? '#0f172a' : '#94a3b8';
            }
        }
    },

    setWidgetSpan(dashboardId, widgetId, span) {
        if (this._finishingWidgets) return;
        const spanNum = parseInt(span, 10);
        const config = this.getWidgetsConfig(dashboardId);
        const widget = config.find(w => w.id === widgetId);
        if (widget) {
            widget.span = spanNum;
            this.saveWidgetsConfig(dashboardId, config);

            const card = document.getElementById(`widget-${widgetId}`);
            if (card) {
                const isEditMode = this.isEditMode(dashboardId);
                if (dashboardId === 'academico') {
                    if (!this._lastAcademicoCtx) { this.reRenderDashboard('academico'); return; }
                    SafeHTML.replace(card, this.renderAcademicoWidget(widget, isEditMode, this._lastAcademicoCtx, config.indexOf(widget)));
                    this.initAcademico();
                } else if (dashboardId === 'rrhh') {
                    const ctx = this._lastRrhhCtx || {};
                    SafeHTML.replace(card, this.renderRrhhWidget(widget, isEditMode, ctx));
                } else if (dashboardId === 'logistica') {
                    const ctx = this._lastLogisticaCtx || {};
                    if (this.renderLogisticaWidget) SafeHTML.replace(card, this.renderLogisticaWidget(widget, isEditMode, ctx));
                } else if (dashboardId === 'alumnocrm') {
                    const ctx = this._lastCrmCtx || {};
                    if (this.renderCrmWidget) SafeHTML.replace(card, this.renderCrmWidget(widget, isEditMode, ctx));
                } else {
                    card.style.gridColumn = `span ${spanNum}`;
                }
            }

            const drawerSelector = document.getElementById(`span-selector-${widgetId}`);
            if (drawerSelector) {
                drawerSelector.querySelectorAll('.span-btn').forEach(btn => {
                    const btnSpan = parseInt(btn.dataset.span, 10);
                    btn.style.background = btnSpan === spanNum ? '#0d9488' : 'white';
                    btn.style.color = btnSpan === spanNum ? 'white' : '#64748b';
                    btn.style.borderColor = btnSpan === spanNum ? '#0d9488' : '#e2e8f0';
                });
            }

            const dropdownSpanLabel = document.getElementById(`dropdown-span-${widgetId}`);
            if (dropdownSpanLabel) {
                dropdownSpanLabel.textContent = `${spanNum}`;
            }
        }
    },

    resetWidgetConfig(dashboardId) {
        const currentUser = typeof AuthManager !== 'undefined' ? AuthManager.getCurrentUser() : null;
        const userId = currentUser ? (currentUser.id || currentUser.username || 'user') : 'default';
        const key = `ecpv_dashboard_config_${dashboardId}_${userId}`;
        BrowserState.removeItem(key);
        if (this._editMode) this._editMode[dashboardId] = false;
        this.reRenderDashboard(dashboardId);
        this._resetWidgetsConfigRemote(dashboardId);
    },

    async _resetWidgetsConfigRemote(dashboardId) {
        try {
            const token = typeof AuthManager !== 'undefined' ? AuthManager.getCsrfToken() : AuthManager.getCsrfToken();
            if (!token) return;
            await fetch(`/api/widget-config/${encodeURIComponent(dashboardId)}`, {
                method: 'DELETE',
                headers: { 'X-SICAF-CSRF': token }
            });
        } catch (e) {
            console.error('Error al restablecer la configuración de widgets en el servidor:', e);
        }
    },

    reRenderDashboard(dashboardId) {
        if (dashboardId === 'academico') {
            const container = document.getElementById('content-area');
            if (container) {
                SafeHTML.set(container, this.renderAcademico());
                this.initAcademico();
            }
        } else if (dashboardId === 'dashboard' && typeof DashboardView !== 'undefined') {
            DashboardView.reRenderProposal();
        } else if (dashboardId === 'alumnocrm') {
            const container = document.getElementById('content-area');
            if (container) SafeHTML.set(container, this.renderAlumnadoCRM());
        } else if (dashboardId === 'rrhh') {
            const container = document.getElementById('content-area');
            if (container) SafeHTML.set(container, this.renderRRHH());
        } else if (dashboardId === 'logistica') {
            const container = document.getElementById('content-area');
            if (container) SafeHTML.set(container, this.renderLogistica());
        }
    },

    readWidgetOrder(dashboardId) {
        const config = this.getWidgetsConfig(dashboardId);
        const cards = document.querySelectorAll(`#widgets-grid-${dashboardId} .dashboard-widget-card`);
        const order = [...new Set(Array.from(cards, card => card.dataset.widgetId))];
        return [...order.map(id => config.find(widget => widget.id === id)).filter(Boolean),
            ...config.filter(widget => !order.includes(widget.id))];
    },

    attachDragAndDrop(dashboardId) {
        if (!this.isEditMode(dashboardId)) return;
        const grid = document.getElementById(`widgets-grid-${dashboardId}`);
        if (!grid) return;

        let draggedCard = null;

        // Las tarjetas pueden estar envueltas en un div `display:contents` (usado para
        // heredar --dnr-i sin romper el grid), por lo que no siempre son hijas directas
        // de `grid`. insertBefore exige que el nodo de referencia sí lo sea, así que
        // subimos hasta encontrar el elemento que realmente cuelga del grid.
        const getGridItem = (el) => {
            let node = el;
            while (node && node.parentElement !== grid) {
                node = node.parentElement;
            }
            return node;
        };

        grid.querySelectorAll('.dashboard-widget-card').forEach(card => {
            // attachDragAndDrop puede volver a invocarse mientras seguimos en modo
            // edición (p.ej. al cambiar el tamaño de un widget); sin esta guarda las
            // tarjetas que no se re-renderizan acumulan listeners duplicados.
            if (card.dataset.dndAttached) return;
            card.dataset.dndAttached = '1';

            // Iniciar el arrastre nativo desde cualquier punto de la tarjeta es poco
            // fiable cuando el cuerpo contiene botones u otros elementos interactivos
            // (p.ej. los botones de "Módulos y Herramientas" o los chips de "Programación
            // y Aulas"): Chrome deja de emitir dragover a mitad de gesto y el drop nunca
            // llega a completarse. Por eso solo se habilita `draggable` mientras el mouse
            // está pulsado sobre el icono ⣿ del header; el resto del tiempo la tarjeta no
            // es arrastrable, así que un clic normal en el contenido nunca lo dispara.
            card.draggable = false;
            const handle = card.querySelector('.drag-handle');
            if (handle) {
                handle.addEventListener('mousedown', () => {
                    if (!this.isEditMode(dashboardId) || this._finishingWidgets) return;
                    card.draggable = true;
                    document.addEventListener('mouseup', () => { card.draggable = false; }, { once: true });
                });
            }

            card.addEventListener('dragstart', (e) => {
                if (!this.isEditMode(dashboardId) || this._finishingWidgets) { e.preventDefault(); return; }
                draggedCard = card;
                e.dataTransfer.effectAllowed = 'move';
                e.dataTransfer.setData('text/plain', card.dataset.widgetId);
                card.style.opacity = '0.4';
            });

            card.addEventListener('dragend', () => {
                if (!draggedCard) return;
                draggedCard = null;
                card.style.opacity = '1';
                card.draggable = false;

                const domCards = Array.from(grid.querySelectorAll('.dashboard-widget-card'));
                const newOrderIds = domCards.map(c => c.dataset.widgetId).filter(Boolean);
                const currentConfig = CategoryDashboards.getWidgetsConfig(dashboardId);
                const reorderedConfig = [];

                newOrderIds.forEach(id => {
                    const item = currentConfig.find(w => w.id === id);
                    if (item) reorderedConfig.push(item);
                });
                currentConfig.forEach(item => {
                    if (!reorderedConfig.find(r => r.id === item.id)) {
                        reorderedConfig.push(item);
                    }
                });

                CategoryDashboards.saveWidgetsConfig(dashboardId, reorderedConfig);
            });

            card.addEventListener('dragover', (e) => {
                if (!this.isEditMode(dashboardId) || this._finishingWidgets) return;
                e.preventDefault();
                e.dataTransfer.dropEffect = 'move';
                if (draggedCard && draggedCard !== card) {
                    const draggedItem = getGridItem(draggedCard);
                    const targetItem = getGridItem(card);
                    if (!draggedItem || !targetItem || draggedItem === targetItem) return;
                    const rect = card.getBoundingClientRect();
                    const midY = rect.top + rect.height / 2;
                    if (e.clientY < midY) {
                        grid.insertBefore(draggedItem, targetItem);
                    } else {
                        grid.insertBefore(draggedItem, targetItem.nextSibling);
                    }
                }
            });
        });
    },

    renderWidgetHeaderControls(dashboardId, widgetId, widgetName, span, isEditMode, maxSpan = 3) {
        const spanButtons = Array.from({ length: maxSpan }, (_, i) => i + 1).map(s => `
            <button type="button" class="span-btn" data-span="${s}" ${UIEvents.attr("click", function(event,captured){CategoryDashboards.setWidgetSpan(String(captured[0]),String(captured[1]),captured[2]);}, [dashboardId, widgetId, s])} style="padding: 1px 5px; font-size: 0.65rem; border-radius: 5px; border: 1px solid ${span === s ? '#0d9488' : '#cbd5e1'}; background: ${span === s ? '#0d9488' : 'white'}; color: ${span === s ? 'white' : '#475569'}; font-weight: 700; cursor: pointer; line-height: 1.6;">${s}</button>
        `).join('');
        return `
            <div class="widget-edit-controls-bar" style="display: ${isEditMode ? 'flex' : 'none'}; position: absolute; top: 0; left: 0; right: 0; align-items: center; justify-content: space-between; background: rgba(248,250,252,0.97); border-bottom: 1px solid #e2e8f0; padding: 0.4rem 0.75rem; border-radius: 18px 18px 0 0; z-index: 10; gap: 6px; overflow: hidden;" ${UIEvents.attr("click", function(event,captured){event.stopPropagation();}, [])}>
                <div style="display: flex; align-items: center; gap: 6px; font-size: 0.72rem; font-weight: 800; color: #0f172a; min-width: 0; flex-shrink: 1; overflow: hidden;">
                    <i class="fas fa-grip-vertical drag-handle" style="color: #0d9488; cursor: grab; font-size: 0.85rem; flex-shrink: 0;" title="Arrastrar para mover"></i>
                    <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${widgetName}</span>
                </div>
                <div style="display: flex; align-items: center; gap: 3px; flex-shrink: 0;">
                    ${spanButtons}
                    <button type="button" ${UIEvents.attr("click", function(event,captured){CategoryDashboards.toggleWidgetVisibility(String(captured[0]),String(captured[1]));}, [dashboardId, widgetId])} style="padding: 1px 5px; font-size: 0.65rem; border-radius: 5px; border: 1px solid #fca5a5; background: #fef2f2; color: #ef4444; font-weight: 700; cursor: pointer; line-height: 1.6;" title="Ocultar widget"><i class="fas fa-eye-slash"></i></button>
                </div>
            </div>
        `;
    },

    renderConfig() {
        return `
            <div style="width: 100%; padding: 2rem 1.5rem; font-family: system-ui, sans-serif;">
                <div style="margin-bottom: 2.5rem;">
                    <h1 style="font-size: 2rem; font-weight: 800; color: #0f172a; margin: 0 0 0.5rem 0; display: flex; align-items: center; gap: 0.75rem;">
                        <i class="fas fa-cog" style="color: #475569;"></i> Ajustes y Configuración
                    </h1>
                    <p style="color: #64748b; font-size: 1rem; margin: 0;">Ajusta configuraciones del sistema, gestiona bases de datos y configura instalaciones.</p>
                </div>

                <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 2rem;">
                    <div ${UIEvents.attr("click", function(event,captured){App.navigate('settings');}, [])} ${UIEvents.attr("mouseover", function(event,captured){this.style.transform='translateY(-4px)';this.style.boxShadow='0 12px 25px rgba(0,0,0,0.08)';}, [])} ${UIEvents.attr("mouseout", function(event,captured){this.style.transform='none';this.style.boxShadow='0 4px 15px rgba(0,0,0,0.03)';}, [])} style="background: white; border: 1px solid #e2e8f0; border-radius: 16px; padding: 2rem; cursor: pointer; transition: all 0.25s ease; box-shadow: 0 4px 15px rgba(0,0,0,0.03);">
                        <div style="font-size: 2rem; color: #475569; margin-bottom: 1.25rem;"><i class="fas fa-calendar-check"></i></div>
                        <h3 style="font-size: 1.15rem; font-weight: 700; color: #0f172a; margin: 0 0 0.5rem 0;">Festivos y Copias de Seguridad</h3>
                        <p style="color: #64748b; font-size: 0.9rem; line-height: 1.5; margin: 0;">Define días no lectivos escolares en el calendario, exporta copias de respaldo de datos (JSON) o importa datos al servidor.</p>
                    </div>
                    <div ${UIEvents.attr("click", function(event,captured){App.navigate('mapa-interactivo');}, [])} ${UIEvents.attr("mouseover", function(event,captured){this.style.transform='translateY(-4px)';this.style.boxShadow='0 12px 25px rgba(0,0,0,0.08)';}, [])} ${UIEvents.attr("mouseout", function(event,captured){this.style.transform='none';this.style.boxShadow='0 4px 15px rgba(0,0,0,0.03)';}, [])} style="background: white; border: 1px solid #e2e8f0; border-radius: 16px; padding: 2rem; cursor: pointer; transition: all 0.25s ease; box-shadow: 0 4px 15px rgba(0,0,0,0.03);">
                        <div style="font-size: 2rem; color: #0ea5e9; margin-bottom: 1.25rem;"><i class="fas fa-map-marked-alt"></i></div>
                        <h3 style="font-size: 1.15rem; font-weight: 700; color: #0f172a; margin: 0 0 0.5rem 0;">Mapa de Aulas</h3>
                        <p style="color: #64748b; font-size: 0.9rem; line-height: 1.5; margin: 0;">Utiliza la herramienta interactiva de trazado gráfico de planos para configurar la distribución física de aulas e instalaciones.</p>
                    </div>
                    <div ${UIEvents.attr("click", function(event,captured){App.navigate('profile');}, [])} ${UIEvents.attr("mouseover", function(event,captured){this.style.transform='translateY(-4px)';this.style.boxShadow='0 12px 25px rgba(0,0,0,0.08)';}, [])} ${UIEvents.attr("mouseout", function(event,captured){this.style.transform='none';this.style.boxShadow='0 4px 15px rgba(0,0,0,0.03)';}, [])} style="background: white; border: 1px solid #e2e8f0; border-radius: 16px; padding: 2rem; cursor: pointer; transition: all 0.25s ease; box-shadow: 0 4px 15px rgba(0,0,0,0.03);">
                        <div style="font-size: 2rem; color: #0d9488; margin-bottom: 1.25rem;"><i class="fas fa-user-circle"></i></div>
                        <h3 style="font-size: 1.15rem; font-weight: 700; color: #0f172a; margin: 0 0 0.5rem 0;">Mi Perfil de Usuario</h3>
                        <p style="color: #64748b; font-size: 0.9rem; line-height: 1.5; margin: 0;">Cambia tu nombre de usuario, actualiza tus datos de visualización, actualiza contraseñas de acceso y cambia tu foto de perfil.</p>
                    </div>
                    ${(typeof AuthManager !== 'undefined' && AuthManager.isAdmin()) ? `
                    <div ${UIEvents.attr("click", function(event,captured){App.navigate('email-settings');}, [])} ${UIEvents.attr("mouseover", function(event,captured){this.style.transform='translateY(-4px)';this.style.boxShadow='0 12px 25px rgba(0,0,0,0.08)';}, [])} ${UIEvents.attr("mouseout", function(event,captured){this.style.transform='none';this.style.boxShadow='0 4px 15px rgba(0,0,0,0.03)';}, [])} style="background: white; border: 1px solid #e2e8f0; border-radius: 16px; padding: 2rem; cursor: pointer; transition: all 0.25s ease; box-shadow: 0 4px 15px rgba(0,0,0,0.03);">
                        <div style="font-size: 2rem; color: #6366f1; margin-bottom: 1.25rem;"><i class="fas fa-envelope-open-text"></i></div>
                        <h3 style="font-size: 1.15rem; font-weight: 700; color: #0f172a; margin: 0 0 0.5rem 0;">Configuración de Email</h3>
                        <p style="color: #64748b; font-size: 0.9rem; line-height: 1.5; margin: 0;">Configura los datos del servidor SMTP, el correo de altas de la asesoría, el correo de entrevistas y la dirección de respuesta.</p>
                    </div>
                    ` : ''}
                </div>
            </div>
        `;
    }
};
